import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Button } from './Button';
import { heroHighlights, offer } from '../data/offer';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-16 pt-14 sm:pb-24 sm:pt-20" data-id="element-107" data-mp="9lv1krql6hwd">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[560px] bg-acad-cream/60" data-id="element-108" data-mp="4mi2n8mfxkdf" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-109" data-mp="12a0j75mcfqrz">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-110" data-mp="x9upzl0fdw7s">
          <p className="mb-5 inline-flex items-center rounded-full border border-acad-gold/60 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-acad-goldDark" data-id="element-111" data-mp="3d1ilrd3pdip0">
            Tap Dance Teacher Ready
          </p>
          <h1 className="mx-auto max-w-4xl font-display text-4xl font-semibold leading-[1.02] text-acad-ink sm:text-6xl lg:text-7xl" data-id="element-112" data-mp="3j9ka79gurdf2">
            Solve an entire year of Tap Dance classes{' '}
            <span className="text-acad-gold" data-id="element-113" data-mp="39b4fyxmj3o1c">in just 5 minutes.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-3xl text-base font-semibold leading-7 text-acad-ink sm:text-lg" data-id="element-114" data-mp="3e8wl4tc6p6nh">
            150 Ready-to-Teach Classes + Complete Technique, Rhythm, Musicality,
            Performance & Teaching Support
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-8 w-full sm:mt-10" data-id="element-115" data-mp="35au9zkyqkxmh">
          <img src={offer.packImage} alt="Tap Dance Teacher Ready complete teaching system: six core volumes, class finder, visual handbooks and five premium bonus guides" className="mx-auto w-full max-w-3xl drop-shadow-[0_22px_34px_rgba(35,38,43,0.16)]" data-id="element-116" data-mp="2ljgyt7f2jrc9" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7" data-id="element-117" data-mp="ici0zaloos78">
          <p className="mx-auto max-w-2xl text-base leading-7 text-acad-muted sm:text-lg" data-id="element-118" data-mp="112g5xhu6q56n">
            A complete professional teaching library built for Tap Dance
            instructors who want to stop creating every class from scratch and
            start walking into the studio with a clear system behind them.
          </p>
          <div className="mt-8" data-id="element-119" data-mp="3hqka8g5ttosb">
            <Button href={offer.checkoutUrl} target="_blank" data-id="element-120" data-mp="3htgaib55cpjx">
              {offer.ctaPrimary}
            </Button>
          </div>
          <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-3 text-sm font-medium text-acad-muted" data-id="element-121" data-mp="21amuv6fipmkr">
            {heroHighlights.map(item => <li key={item} className="flex items-center gap-2" data-id="element-122" data-mp="26868q58azxc6">
                <CheckCircle2Icon size={17} className="shrink-0 text-acad-gold" aria-hidden="true" data-id="element-123" data-mp="2b2ag2plhe7ds" />
                {item}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}